<template>
  <div class="header d-flex justify-content-center">
    <div class="nav-menu mt-4">
			<a :href="$t('home_button_url')" class="btn btn-light home-btn">
				{{ $t('home_button_label') }}
			</a>
      <div class="btn-group" v-if="state.availableLangs.length > 1">
        <button class="btn btn-light dropdown-toggle"  id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
          {{ $i18n.locale.toUpperCase() }}
        </button>
        <ul class="dropdown-menu lang_selecter" aria-labelledby="defaultDropdown">
          <li v-for="language in state.availableLangs" :key="language">
            <a @click.prevent="setLanguage(language)" class="dropdown-item" href="#">{{ language.lang.toUpperCase() }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";
import { i18n, setI18nLanguage } from '@/i18n'
import router from '@/router'

export default {
  name: "Header",
  data() {
    return {
      lang: []
    }
  },
  setup() {
    const store = inject("store");
    return {
      state: store.state,
			actions: store.actions
    };
  },
	methods: {
		setLanguage(lang) {
			if(this.state.availableLocales.includes(lang.lang)) {
				setI18nLanguage( i18n, lang );
				router.push(`/${lang.lang}`)
			}
		}
	}
}
</script>
<style scoped>
.header {
  position: absolute;
  width: 100%;
  z-index: 2;
	font-family: 'ProximaSoft';
}
.nav-menu {
  display: flex;
  max-width: 519px;
  width: 100%;
  justify-content: space-between;
}
.lang_selecter {
  min-width: 87px !important;
}
.btn-light {
  color: #000;
  background-color: #fff;
  border-color: #fff;
  font-weight: bold;
}
.home-btn {
  font-size: 16px;
  text-align: center;
}
@media (max-width: 414px) {
  .header {
    padding: 0px 10px;
  }
}
</style>
